export default {
  namespaced: true,
  state() {
    return {
      genders: ["Male", "Female", "Rather not say"],
    };
  },
  getters: {
    genders(state) {
      return state.genders;
    },
  },
  mutations: {},
  actions: {},
  modules: {},
};
